import { getCdnUrl } from 'owa-config/lib/bootstrapOptions';
import { M365HubApplication } from 'owa-graph-schema';
import loc from 'owa-localize';
import { appCalendar } from 'owa-locstrings/lib/strings/appcalendar.locstring.json';
import { appEventify } from 'owa-locstrings/lib/strings/appEventify.locstring.json';
import { appFeed } from 'owa-locstrings/lib/strings/appFeed.locstring.json';
import { appFiles } from 'owa-locstrings/lib/strings/appFiles.locstring.json';
import { appPeople } from 'owa-locstrings/lib/strings/apppeople.locstring.json';
import { appTasks } from 'owa-locstrings/lib/strings/apptasks.locstring.json';
import { appToDo } from 'owa-locstrings/lib/strings/apptodo.locstring.json';
import { mailAppName } from 'owa-locstrings/lib/strings/mailAppName.locstring.json';
//import { meetApp } from 'owa-locstrings/lib/strings/meetApp.locstring.json';
import { getPaletteAsRawColors } from 'owa-theme';
import { AppTilePreviewCommand } from 'appservices-utils/lib/data/AppTilePreviewCommand';
import isMOSLaunchPagesEnabled from 'owa-left-rail-utils/lib/utils/isMOSLaunchPagesEnabled';

const CDN_URL = getCdnUrl();

// note: localization doesn't yet work on the owa-data-worker.
// see https://outlookweb.visualstudio.com/Outlook%20Web/_workitems/edit/135081
// that means loc(mailAppName) will return undefined, so as a temporary work around while the
// worker flight is tiny, there's the fallback to || 'Mail'
export default function (): M365HubApplication[] {
    const theme = getPaletteAsRawColors();

    return [
        {
            __typename: 'M365HubApplication',
            accessibleName: loc(mailAppName) || 'Mail',
            badge: {
                __typename: 'M365ApplicationNumericBadge',
                count: 0,
                countDescription: 'Empty',
            },
            brandingColor: theme.themePrimary,
            canLaunchOut: true,
            command: {
                command: {
                    stateTransition: 'flush',
                    visibilityState: 'show',
                },
                entity: {
                    action: 'default',
                    entityId: 'Mail',
                    type: 'outlook_mail',
                },
            },
            icon: {
                __typename: 'InternalIcon',
                name: 'MailIcon',
            },
            id: 'DDEA774C-382B-47D7-AAB5-ADC2139A802B',
            isInUse: false,
            isPinnable: false,
            lockedIndex: 0,
            name: loc(mailAppName) || 'Mail',
            pinnedIndex: null,
            selectedStateIconOverride: {
                __typename: 'InternalIcon',
                name: 'MailIconSelected',
            },
            secondaryCommands: [],
        },
        {
            __typename: 'M365HubApplication',
            accessibleName: loc(appCalendar) || 'Calendar',
            badge: {
                __typename: 'M365ApplicationNumericBadge',
                count: 0,
                countDescription: 'Empty',
            },
            brandingColor: theme.themePrimary,
            canLaunchOut: true,
            command: {
                command: {
                    stateTransition: 'flush',
                    visibilityState: 'show',
                },
                entity: {
                    action: 'default',
                    entityId: 'Calendar',
                    type: 'outlook_calendar',
                },
            },
            icon: {
                __typename: 'InternalIcon',
                name: 'OutlookCalendarIcon',
            },
            id: '8CBEB86F-83E1-43B5-AABA-CD3514322F0B',
            isInUse: false,
            isPinnable: false,
            lockedIndex: 1,
            name: loc(appCalendar) || 'Calendar',
            pinnedIndex: null,
            selectedStateIconOverride: {
                __typename: 'InternalIcon',
                name: 'OutlookCalendarIconSelected',
            },
            secondaryCommands: [],
        },
        {
            __typename: 'M365HubApplication',
            accessibleName: loc(appPeople) || 'People',
            badge: {
                __typename: 'M365ApplicationNumericBadge',
                count: 0,
                countDescription: 'Empty',
            },
            brandingColor: theme.themePrimary,
            canLaunchOut: true,
            command: {
                command: {
                    stateTransition: 'flush',
                    visibilityState: 'show',
                },
                entity: {
                    action: 'default',
                    entityId: 'People',
                    type: 'outlook_people',
                },
            },
            icon: {
                __typename: 'InternalIcon',
                name: 'PeopleIcon',
            },
            id: '355FBD79-3BA2-4554-8F2D-0300FDE91F30',
            isInUse: false,
            isPinnable: false,
            lockedIndex: 2,
            name: loc(appPeople) || 'People',
            pinnedIndex: null,
            selectedStateIconOverride: {
                __typename: 'InternalIcon',
                name: 'PeopleIconSelected',
            },
            secondaryCommands: [],
        },
        {
            __typename: 'M365HubApplication',
            accessibleName: loc(appFiles) || 'Files',
            badge: {
                __typename: 'M365ApplicationNumericBadge',
                count: 0,
                countDescription: 'Empty',
            },
            brandingColor: theme.themePrimary,
            canLaunchOut: true,
            command: {
                command: {
                    stateTransition: 'flush',
                    visibilityState: 'show',
                },
                entity: {
                    action: 'default',
                    entityId: 'FilesHub',
                    type: 'outlook_fileshub',
                },
            },
            icon: {
                __typename: 'InternalIcon',
                name: 'OutlookFilesIcon',
            },
            id: 'D7A12BEA-E4FE-49A7-8CD1-C2E6D53722A6',
            isInUse: false,
            isPinnable: false,
            lockedIndex: 3,
            name: loc(appFiles) || 'Files',
            pinnedIndex: null,
            selectedStateIconOverride: {
                __typename: 'InternalIcon',
                name: 'OutlookFilesIconSelected',
            },
            secondaryCommands: [],
        },
        {
            __typename: 'M365HubApplication',
            accessibleName: loc(appToDo) || 'To Do',
            badge: {
                __typename: 'M365ApplicationNumericBadge',
                count: 0,
                countDescription: 'Empty',
            },
            brandingColor: theme.themePrimary,
            canLaunchOut: true,
            command: {
                command: {
                    stateTransition: 'flush',
                    visibilityState: 'show',
                },
                entity: {
                    action: 'default',
                    entityId: 'Tasks',
                    type: 'outlook_todo',
                },
            },
            icon: {
                __typename: 'RemoteImage',
                src: `${CDN_URL}todo/publicIcons/todo-metaos-32.png`,
            },
            id: '59391057-d7d7-49fd-a041-d8e4080f05ec',
            isInUse: false,
            isPinnable: false,
            lockedIndex: 4,
            name: loc(appToDo) || 'To Do',
            pinnedIndex: null,
            selectedStateIconOverride: {
                __typename: 'RemoteImage',
                src: `${CDN_URL}todo/publicIcons/todo-metaos-32.png`,
            },
            secondaryCommands: isMOSLaunchPagesEnabled() ? [AppTilePreviewCommand] : [],
        },
        {
            __typename: 'M365HubApplication',
            accessibleName: loc(appTasks) || 'Tasks',
            badge: {
                __typename: 'M365ApplicationNumericBadge',
                count: 0,
                countDescription: 'Empty',
            },
            brandingColor: theme.themePrimary,
            canLaunchOut: true,
            command: {
                command: {
                    stateTransition: 'flush',
                    visibilityState: 'show',
                },
                entity: {
                    action: 'default',
                    entityId: 'Tasks',
                    type: 'outlook_tasks',
                },
            },
            icon: {
                __typename: 'InternalIcon',
                name: 'OutlookTasksIcon',
            },
            id: 'e9f9b6d1-7948-4b5b-84f2-8a97e3fdb427',
            isInUse: false,
            isPinnable: false,
            lockedIndex: null,
            name: loc(appTasks) || 'Tasks',
            pinnedIndex: null,
            selectedStateIconOverride: {
                __typename: 'InternalIcon',
                name: 'OutlookTasksIcon',
            },
            secondaryCommands: [],
        },
        {
            __typename: 'M365HubApplication',
            accessibleName: loc(appFeed) || 'Feed',
            badge: {
                __typename: 'M365ApplicationNumericBadge',
                count: 0,
                countDescription: 'Empty',
            },
            brandingColor: theme.themePrimary,
            canLaunchOut: true,
            command: {
                command: {
                    stateTransition: 'flush',
                    visibilityState: 'show',
                },
                entity: {
                    action: 'default',
                    entityId: 'Feed',
                    type: 'outlook_feed',
                },
            },
            icon: {
                __typename: 'RemoteImage',
                src: 'https://res.cdn.office.net/midgard/versionless/feed_icon_dark_32.png',
            },
            id: '261d33d6-15ba-4e1d-b298-8096960fab40',
            isInUse: false,
            isPinnable: false,
            lockedIndex: 5,
            name: loc(appFeed) || 'Feed',
            pinnedIndex: null,
            selectedStateIconOverride: {
                __typename: 'RemoteImage',
                src: 'https://res.cdn.office.net/midgard/versionless/feed_icon_32.png',
            },
            secondaryCommands: [],
        },
        {
            __typename: 'M365HubApplication',
            accessibleName: loc(appEventify) || 'Discover events on Eventify',
            badge: {
                __typename: 'M365ApplicationNumericBadge',
                count: 0,
                countDescription: 'Empty',
            },
            brandingColor: theme.themePrimary,
            canLaunchOut: true,
            command: {
                command: {
                    stateTransition: 'flush',
                    visibilityState: 'show',
                },
                entity: {
                    action: 'default',
                    entityId: 'Eventify',
                    type: 'outlook_eventify',
                },
            },
            icon: {
                __typename: 'RemoteImage',
                src: `${CDN_URL}assets/eventify/logo/24.svg`,
            },
            id: '9d4ccf05-fca9-4c39-8e31-28f49a4f8e0a',
            isInUse: false,
            isPinnable: false,
            lockedIndex: 8,
            name: loc(appEventify) || 'Eventify',
            pinnedIndex: null,
            selectedStateIconOverride: {
                __typename: 'RemoteImage',
                src: `${CDN_URL}assets/eventify/logo/24.svg`,
            },
            secondaryCommands: [],
        },
        {
            __typename: 'M365HubApplication',
            accessibleName: loc(appToDo),
            badge: {
                __typename: 'M365ApplicationNumericBadge',
                count: 0,
                countDescription: 'Empty',
            },
            brandingColor: theme.themePrimary,
            canLaunchOut: true,
            command: {
                command: {
                    stateTransition: 'flush',
                    visibilityState: 'show',
                },
                entity: {
                    action: 'default',
                    entityId: 'Tasks',
                    type: 'outlook_tasks',
                },
            },
            icon: {
                __typename: 'InternalIcon',
                name: 'OutlookTasksIcon',
            },
            id: '875f4f64-6691-4ae8-990e-4ab948ccb7d7',
            isInUse: false,
            isPinnable: false,
            lockedIndex: 6,
            name: loc(appToDo),
            pinnedIndex: null,
            selectedStateIconOverride: {
                __typename: 'InternalIcon',
                name: 'OutlookTasksIcon',
            },
            secondaryCommands: [],
        },
        {
            __typename: 'M365HubApplication',
            accessibleName: 'Meet',
            badge: {
                __typename: 'M365ApplicationNumericBadge',
                count: 0,
                countDescription: 'Empty',
            },
            brandingColor: theme.themePrimary,
            canLaunchOut: true,
            command: {
                command: {
                    stateTransition: 'flush',
                    visibilityState: 'show',
                },
                entity: {
                    action: 'default',
                    entityId: '957ed0e3-e5ca-4c82-9676-fd037185c4d8',
                    type: 'm365_app',
                },
            },
            icon: {
                __typename: 'RemoteImage',
                src:
                    'https://statics.teams.cdn.office.net/evergreen-assets/apps/957ed0e3-e5ca-4c82-9676-fd037185c4d8_smallImage.png?v=1.0.0',
            },
            id: '957ed0e3-e5ca-4c82-9676-fd037185c4d8',
            isInUse: false,
            isPinnable: false,
            lockedIndex: 7,
            name: 'Test',
            pinnedIndex: null,
            selectedStateIconOverride: {
                __typename: 'RemoteImage',
                src:
                    'https://statics.teams.cdn.office.net/evergreen-assets/apps/957ed0e3-e5ca-4c82-9676-fd037185c4d8_smallImage.png?v=1.0.0',
            },
            secondaryCommands: [],
        },
        {
            __typename: 'M365HubApplication',
            accessibleName: 'Test',
            badge: {
                __typename: 'M365ApplicationNumericBadge',
                count: 0,
                countDescription: 'Empty',
            },
            brandingColor: theme.themePrimary,
            canLaunchOut: true,
            command: {
                command: {
                    stateTransition: 'flush',
                    visibilityState: 'show',
                },
                entity: {
                    action: 'default',
                    entityId: 'com.example.metaostestapp.test',
                    type: 'm365_app',
                },
            },
            icon: {
                __typename: 'InternalIcon',
                name: 'ActivityIcon',
            },
            id: 'com.example.metaostestapp.test',
            isInUse: false,
            isPinnable: false,
            lockedIndex: 8,
            name: 'Test',
            pinnedIndex: null,
            selectedStateIconOverride: {
                __typename: 'InternalIcon',
                name: 'ActivityIconSelected',
            },
            secondaryCommands: [],
        },
    ];
}
